import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import countrys from './country';


const Userdetail = () => {

    const [fname, setFname] = useState('')
    const [lname, setLname] = useState('')
    const [email, setEmail] = useState('')
    const [country, setCountry] = useState('')
    const [address, setAddress] = useState('')
    const [city, setCity] = useState('')
    const [state, setState] = useState('')
    const [zipcode, setZipcode] = useState('')

    const handleSaveaddress = (e) => {
        e.preventDefault();
        console.log({ fname, lname, email, country, address, city, state, zipcode })
    }


    return (
        <>
            <div style={{
                width: '80%', margin: '.5rem auto', backgroundColor: 'white', padding: '1.5rem',
                boxShadow: ' rgba(0, 0, 0, 0.35) 0px 5px 15px', marginBottom: '2rem', borderRadius: '.7rem',
            }}>
                <p style={{ fontSize: '1.5rem', textAlign: 'center', marginBottom: '1rem', color: 'green' }}>Fill all important detail to get your order at right place </p>
                <div className="border-b border-gray-900/10 mb-10 pb-12">
                    <h2 className="text-base font-semibold leading-7 text-gray-900">Personal Information</h2>
                    <p className="mt-1 text-sm leading-6 text-gray-600">Use a permanent address where you can receive mail.</p>

                    <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                        <div className="sm:col-span-3">
                            <label htmlFor="first-name" className="block text-sm font-medium leading-6 text-gray-900">
                                First name
                            </label>
                            <div className="mt-2">
                                <input
                                    value={fname}
                                    onChange={(e) => setFname(e.target.value)}
                                    type="text"
                                    name="first-name"
                                    id="first-name"
                                    autoComplete="given-name"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>

                        <div className="sm:col-span-3">
                            <label htmlFor="last-name" className="block text-sm font-medium leading-6 text-gray-900">
                                Last name
                            </label>
                            <div className="mt-2">
                                <input
                                    value={lname}
                                    onChange={(e) => setLname(e.target.value)}
                                    type="text"
                                    name="last-name"
                                    id="last-name"
                                    autoComplete="family-name"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>

                        <div className="sm:col-span-4">
                            <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                                Email address
                            </label>
                            <div className="mt-2">
                                <input
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    id="email"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>

                        <div className="sm:col-span-3">
                            <label htmlFor="country" className="block text-sm font-medium leading-6 text-gray-900">
                                Country
                            </label>
                            <div className="mt-2">
                                <select
                                    id="country"
                                    name="country"
                                    autoComplete="country-name"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
                                    value={country}
                                    onChange={(e) => setCountry(e.target.value)}
                                >
                                    {
                                        countrys.map((ele) => {
                                            return <option value={ele}>{ele}</option>

                                        })
                                    }
                                </select>
                            </div>
                        </div>

                        <div className="col-span-full">
                            <label htmlFor="street-address" className="block text-sm font-medium leading-6 text-gray-900">
                                Street address
                            </label>
                            <div className="mt-2">
                                <input
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                    type="text"
                                    name="street-address"
                                    id="street-address"
                                    autoComplete="street-address"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>

                        <div className="sm:col-span-2 sm:col-start-1">
                            <label htmlFor="city" className="block text-sm font-medium leading-6 text-gray-900">
                                City
                            </label>
                            <div className="mt-2">
                                <input
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                    type="text"
                                    name="city"
                                    id="city"
                                    autoComplete="address-level2"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>

                        <div className="sm:col-span-2">
                            <label htmlFor="region" className="block text-sm font-medium leading-6 text-gray-900">
                                State / Province
                            </label>
                            <div className="mt-2">
                                <input
                                    value={state}
                                    onChange={(e) => setState(e.target.value)}
                                    type="text"
                                    name="region"
                                    id="region"
                                    autoComplete="address-level1"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>

                        <div className="sm:col-span-2">
                            <label htmlFor="postal-code" className="block text-sm font-medium leading-6 text-gray-900">
                                ZIP / Postal code
                            </label>
                            <div className="mt-2">
                                <input
                                    value={zipcode}
                                    onChange={(e) => setZipcode(e.target.value)}
                                    type="text"
                                    name="postal-code"
                                    id="postal-code"
                                    autoComplete="postal-code"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="mt-6 flex items-center justify-end gap-x-6">

                        <button onClick={handleSaveaddress}
                            type="submit"
                            className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                            Save address
                        </button>
                    </div>
                    <br />

                    <div style={{ boxShadow: ' rgba(0, 0, 0, 0.35) 0px 5px 15px', backgroundColor: 'aqua', cursor: 'pointer', padding: '1rem', borderRadius: '.7rem', color: 'green' }}>
                        <div className="flex items-center gap-x-3">

                            <input

                                id="set_address"
                                name="push-notifications"
                                type="radio"
                                className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
                            />
                            <label htmlFor="set_address" className="block text-sm font-medium leading-6 text-gray-900">

                                <div className='container-fluid'>
                                    <div>
                                        <div style={{ width: '80%', margin: '0rem auto', padding: '.7rem', color: 'white' }}>
                                            <div className="mt-8">
                                                <div className="flow-root">
                                                    <ul role="list" className="-my-6 divide-y divide-gray-200">

                                                        <li className="flex py-6">
                                                            <p style={{ marginRight: '0rem' }}>  Harikesh maurya</p>

                                                            <div className="ml-4 flex flex-1 flex-col">
                                                                <div>
                                                                    <div className="flex justify-between text-base font-medium text-gray-900">

                                                                        <p className="text-gray-900 " style={{ width: '15rem', wordWrap: 'break-word' }}>
                                                                            <h2 style={{ textAlign: 'center' }}>
                                                                                Address : {address} </h2>
                                                                        </p>

                                                                        <div className="flex justify-between text-base font-medium text-gray-100" style={{ width: '15rem', color: 'green' }}>
                                                                            <p style={{ textAlign: 'center' }}>Phone : <br />7238007782</p>
                                                                        </div>

                                                                    </div>

                                                                </div>



                                                            </div>
                                                        </li>

                                                        <br />
                                                    </ul>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>

                            </label>

                        </div>
                    </div>


                </div>

                <div className="border-b border-gray-900/10 pb-12">
                    <h2 className="text-base font-semibold leading-7 text-gray-900">Notifications</h2>
                    <p className="mt-1 text-sm leading-6 text-gray-600">
                        We'll always let you know about important changes, but you pick what else you want to hear about.
                    </p>

                    <div className="mt-10 space-y-10">

                        <fieldset>
                            <legend className="text-sm font-semibold leading-6 text-gray-900">payment methods</legend>

                            <div className="mt-6 space-y-6">

                                <div className="flex items-center gap-x-3">
                                    <input
                                        value={fname}
                                        onChange={(e) => (e.target.value)}
                                        id="push-email"
                                        name="push-notifications"
                                        type="radio"
                                        className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
                                    />
                                    <label htmlFor="push-email" className="block text-sm font-medium leading-6 text-gray-900">
                                        cash on delivery
                                    </label>
                                </div>
                                <div className="flex items-center gap-x-3">
                                    <input
                                        value={fname}
                                        onChange={(e) => (e.target.value)}
                                        id="push-nothing"
                                        name="push-notifications"
                                        type="radio"
                                        className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
                                    />
                                    <label htmlFor="push-nothing" className="block text-sm font-medium leading-6 text-gray-900">
                                        pay online / card
                                    </label>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>


                <div className="mt-6 flex items-center justify-end gap-x-6">
                    <NavLink to='/cart/order' >
                        <button type="button" className="text-sm font-semibold leading-6 text-gray-900">
                            Cancel
                        </button>
                    </NavLink>
                    <NavLink to='/cart/order/pay'>
                        <button
                            type="submit"
                            className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                            pay now
                        </button>
                    </NavLink>
                </div>
            </div>
        </>
    )
}

export default Userdetail;